(() => {
  if (!('IntersectionObserver' in window) || !Element.prototype.animate) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  const running = new Set();
  let observer;
  const start = () => {
    if (reduced.matches) return;
    const targets = document.querySelectorAll('#MainContent h2, #MainContent .dp-card, #MainContent .product-card-wrapper, #MainContent .dp-pdp-time__step, .dp-footer__newsletter-title');
    observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        observer.unobserve(entry.target);
        if (reduced.matches || document.hidden || entry.target.contains(document.activeElement)) continue;
        const animation = entry.target.animate(
          [{ transform: 'translateY(10px)', opacity: 0.9 }, { transform: 'translateY(0)', opacity: 1 }],
          { duration: 320, easing: 'cubic-bezier(.2,.65,.3,1)' }
        );
        running.add(animation);
        animation.finished.then(() => running.delete(animation), () => running.delete(animation));
      }
    }, { threshold: 0.05 });
    for (const element of targets) {
      if (seen.has(element) || element.closest('.scroll-trigger, [hidden], .dp-pdp-main-section')) continue;
      seen.add(element);
      const rect = element.getBoundingClientRect();
      if (rect.width && rect.height && rect.top >= innerHeight) observer.observe(element);
    }
  };
  const schedule = () => {
    if ('requestIdleCallback' in window) requestIdleCallback(start, { timeout: 2000 });
    else setTimeout(start, 200);
  };
  reduced.addEventListener('change', () => {
    observer?.disconnect();
    for (const animation of running) animation.cancel();
    if (!reduced.matches) schedule();
  });
  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule, { once: true });
})();

(() => {
  if (!Element.prototype.animate) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const running = new Map();
  const selector = 'details.dp-acc__item > summary, details.dp-faq__item > summary';

  const settle = (details, state) => {
    if (running.get(details) !== state) return;
    running.delete(details);
    if (state.animation) {
      state.animation.onfinish = null;
      state.animation.cancel();
    }
    details.open = state.open;
    details.style.height = state.height;
    details.style.overflow = state.overflow;
    details.removeAttribute('data-dp-expanded');
    state.summary.setAttribute('aria-expanded', String(state.open));
  };

  document.addEventListener('click', (event) => {
    const summary = event.target.closest?.(selector);
    if (!summary || event.defaultPrevented || event.button !== 0 || reduced.matches) return;
    if (event.target.closest('a, button, input, select, textarea')) return;
    const details = summary.parentElement;
    const previous = running.get(details);
    const open = previous ? !previous.open : !details.open;
    const start = details.getBoundingClientRect().height;
    if (!start) return;
    event.preventDefault();
    const state = {
      open, summary, animation: null,
      height: previous ? previous.height : details.style.height,
      overflow: previous ? previous.overflow : details.style.overflow,
    };
    if (previous?.animation) {
      previous.animation.onfinish = null;
      previous.animation.cancel();
    }
    running.set(details, state);
    details.style.height = 'auto';
    details.style.overflow = 'hidden';
    details.open = true;
    details.setAttribute('data-dp-expanded', String(open));
    summary.setAttribute('aria-expanded', String(open));
    const style = getComputedStyle(details);
    const edges = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth)
      + parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
    const end = open ? details.getBoundingClientRect().height : summary.getBoundingClientRect().height + edges;
    details.style.height = `${start}px`;
    if (Math.abs(start - end) < 1) {
      settle(details, state);
      return;
    }
    try {
      state.animation = details.animate(
        [{ height: `${start}px` }, { height: `${end}px` }],
        { duration: open ? 360 : 280, easing: 'cubic-bezier(.22, 1, .36, 1)', fill: 'both' }
      );
      state.animation.onfinish = () => settle(details, state);
    } catch {
      settle(details, state);
    }
  });

  const finishAll = () => {
    for (const [details, state] of running) settle(details, state);
  };
  window.addEventListener('resize', finishAll, { passive: true });
  window.addEventListener('pagehide', finishAll);
  reduced.addEventListener('change', finishAll);
})();
